module.exports = __webpack_public_path__ + "static/media/logo_slam_uncut.da34aea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/slam/logo_slam_uncut.png
// module id = 613
// module chunks = 0